// 'formulario' icono igual que 'introduccion-directa'
export const icons = {
  'formulario': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 4v11"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M8 11l4 4 4-4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 19h16"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  ),
  // ...otros iconos...
  perfil: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-4.418 0-8 2.239-8 5v1h16v-1c0-2.761-3.582-5-8-5Z"
        fill="currentColor"
      />
    </svg>
  ),

  'mis-preguntas': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm2 4h6M9 11h6M9 15h4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  'estadisticas-publicas': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3a9 9 0 1 0 9 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 3v9h9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9l6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M15 9l-6 6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),


  'revision-preguntas': (
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="22" height="22" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M227 4936 c-61 -17 -122 -59 -164 -114 -68 -89 -63 59 -61 -2122 l3
-1975 24 -49 c29 -60 85 -117 143 -148 l43 -23 1490 0 1490 0 54 30 c66 37
115 92 141 162 18 49 20 78 20 312 l0 258 58 21 57 22 107 -107 107 -106 -20
-25 c-12 -15 -19 -40 -19 -66 0 -41 3 -44 363 -403 397 -397 401 -400 543
-424 142 -25 286 24 386 129 113 118 152 265 113 417 -31 117 -52 142 -420
513 l-350 352 -46 0 c-32 0 -55 -6 -70 -19 l-24 -20 -106 106 -107 105 25 60
c84 208 89 463 13 682 -27 79 -90 194 -145 266 -97 126 -267 254 -401 302
l-64 23 0 173 0 174 -29 29 c-22 21 -39 29 -66 29 -88 0 -105 -35 -105 -218
l0 -139 -127 -6 c-152 -6 -248 -29 -378 -91 -257 -122 -434 -335 -517 -623
-20 -68 -23 -100 -22 -248 1 -154 3 -178 27 -258 125 -408 466 -673 895 -694
l122 -6 0 -218 c0 -148 -4 -227 -12 -244 -26 -58 58 -55 -1499 -55 l-1431 0
-34 34 -34 34 0 1946 c0 1721 2 1950 15 1976 33 64 -66 60 1490 60 1237 0
1420 -2 1445 -15 58 -30 60 -40 60 -263 0 -255 10 -282 108 -282 33 0 45 6 66
31 l26 31 0 217 c0 165 -4 230 -15 269 -20 68 -96 151 -167 183 l-53 24 -1450
2 c-1166 1 -1459 -1 -1498 -11z m3023 -2010 c297 -54 520 -259 602 -553 27
-99 29 -265 4 -368 -22 -94 -94 -237 -153 -308 -205 -245 -532 -334 -840 -228
-106 37 -178 80 -264 159 -167 154 -247 353 -237 591 6 131 38 244 99 349 55
92 200 230 294 279 163 84 324 110 495 79z m720 -1601 l-85 -85 -88 88 -88 89
83 85 83 85 90 -88 90 -89 -85 -85z m923 -600 c30 -56 30 -164 0 -220 -25 -47
-64 -85 -113 -111 -48 -25 -162 -25 -210 0 -19 10 -169 151 -332 314 l-298
297 172 172 173 173 293 -292 c161 -161 303 -311 315 -333z"/>
<path d="M3193 2268 l-223 -222 -98 97 c-93 91 -102 97 -140 97 -62 0 -97 -34
-97 -94 0 -47 0 -47 146 -191 143 -142 146 -145 189 -145 l44 0 263 262 c171
171 267 273 273 294 21 62 -26 124 -94 124 -39 0 -47 -7 -263 -222z"/>
<path d="M569 4201 l-29 -29 0 -316 0 -316 29 -32 29 -33 321 0 321 0 27 28
28 27 3 307 c2 219 -1 315 -9 335 -24 58 -25 58 -372 58 l-319 0 -29 -29z
m531 -351 l0 -180 -180 0 -180 0 0 180 0 180 180 0 180 0 0 -180z"/>
<path d="M1703 4212 c-58 -45 -46 -139 21 -167 30 -13 120 -15 541 -15 539 0
559 2 584 48 20 38 13 94 -16 124 l-27 28 -540 0 c-497 0 -543 -2 -563 -18z"/>
<path d="M3248 3917 c-35 -32 -44 -77 -23 -117 19 -37 73 -63 110 -54 38 9 75
59 75 101 0 79 -104 124 -162 70z"/>
<path d="M1714 3791 c-61 -37 -65 -115 -8 -160 26 -21 34 -21 406 -21 423 0
418 -1 439 69 14 47 0 85 -43 111 -31 19 -51 20 -398 20 -342 0 -367 -1 -396
-19z"/>
<path d="M569 3071 l-29 -29 0 -311 c0 -211 4 -318 11 -335 25 -53 51 -57 385
-54 l306 3 29 33 29 32 0 306 c0 324 -3 349 -49 374 -12 6 -138 10 -336 10
l-317 0 -29 -29z m531 -351 l0 -180 -180 0 -180 0 0 180 0 180 180 0 180 0 0
-180z"/>
<path d="M1723 3090 c-31 -13 -57 -57 -57 -98 0 -26 8 -41 32 -63 l32 -29 236
0 c184 0 241 3 263 14 66 35 66 137 0 172 -22 11 -77 14 -256 13 -125 0 -238
-4 -250 -9z"/>
<path d="M1702 2645 c-38 -32 -46 -65 -28 -109 21 -52 63 -69 154 -64 69 3 76
6 103 36 32 36 36 69 14 112 -22 42 -43 50 -134 50 -70 0 -83 -3 -109 -25z"/>
<path d="M569 1941 l-29 -29 0 -312 c0 -337 2 -354 55 -378 18 -8 116 -12 331
-12 l306 0 34 34 34 34 0 307 c0 318 -2 333 -44 367 -19 16 -53 18 -339 18
l-319 0 -29 -29z m531 -351 l0 -180 -180 0 -180 0 0 180 0 180 180 0 180 0 0
-180z"/>
<path d="M1702 1945 c-38 -32 -46 -65 -28 -109 21 -52 63 -69 154 -64 69 3 76
6 103 36 42 47 36 103 -15 144 -16 13 -40 18 -103 18 -72 0 -85 -3 -111 -25z"/>
<path d="M1730 1537 c-49 -17 -76 -72 -60 -122 21 -64 27 -65 303 -65 l249 0
29 29 c51 52 33 128 -37 157 -43 18 -431 19 -484 1z"/>
</g>
</svg>

  ),

  'gestion-preguntas': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 5h16M4 12h16M4 19h10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18 16l2 2 4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  'moderacion-usuarios': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3ZM8 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z"
        fill="currentColor"
      />
      <path
        d="M2 19c0-2.5 3-4 6-4s6 1.5 6 4M14 15c2.8.2 5 1.6 5 4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),

  'introduccion-directa': (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 4v11"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M8 11l4 4 4-4"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 19h16"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  ),

  'inicio-concurso': (
    <svg width="22" height="22" viewBox="0 0 64 64" fill="none">
      <path
        d="M20 8H44V18C44 25.732 38.627 32 32 32C25.373 32 20 25.732 20 18V8Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M20 12H12C12 20 16 24 22 24"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44 12H52C52 20 48 24 42 24"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 32V42"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M24 54H40"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M26 42H38V46C38 50.418 35.314 54 32 54C28.686 54 26 50.418 26 46V42Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="20" r="4" fill="currentColor" />
    </svg>
  ),
};